module.exports = __webpack_public_path__ + "static/img/2-5-普通维修.71ca2bc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jushuitan/2-5-普通维修.png
// module id = 1317
// module chunks = 0